<template>

    <div class="p-relative">

        <Toolbar
            :is-list="true"
            v-on:toolbar-button-click="onToolbarClick"
        >
            <SearchPanel
                v-model="search"
                :has-filter="false"
            />
        </Toolbar>

        <v-row no-gutters>

            <v-col cols="12" xs="12" md="12">
                <v-data-table
                    :loading="loading"
                    :headers="headers"
                    :items="entities"
                    :options.sync="options"
                    :server-items-length="total"
                    :items-per-page="10"
                    :footer-props="{ itemsPerPageOptions:[5, 10, 20] }"
                    :page.sync="options.page"
                    @page-count="paginationPageCount = $event"
                    class="elevation-1 customization-list-table pagination-list-table sticky-table"
                    @dblclick:row="rowClick"
                >

                    <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate></v-progress-linear>

                    <template v-slot:[`item.name`]="{ item }">
                        <div class="elipsis-text-wrap">
                            <div class="etw-text-container">
                                <div class="etw-text" v-tooltip.top-center="item.name">
                                    {{ item.name }}
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`item.description`]="{ item }">
                        <div class="elipsis-text-wrap">
                            <div class="etw-text-container">
                                <div class="etw-text" v-tooltip.top-center="item.description">
                                    {{ item.description }}
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`item.context_types`]="{ item }">
                        <div class="elipsis-text-wrap">
                            <div class="etw-text-container">
                                <div class="etw-text" v-tooltip.top-center="item.document_type">
                                    {{ getContextTypesViewValue(item.context_types) }}
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`footer.prepend`]>
                        <v-pagination
                            v-model="options.page"
                            :length="paginationPageCount"
                            :total-visible="$listPaginationTotal"
                            color="teal"
                        ></v-pagination>
                    </template>

                </v-data-table>
            </v-col>

        </v-row>

    </div>

</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';

import { httpAPI } from "@/api/httpAPI";
import Toolbar from '@/components/documents/Toolbar.vue';
import SearchPanel from '@/components/documents/SearchPanel.vue';

export default {
    name: "Workflows",
    columnIndex:  {
        'version': 2,
        'name': 3,
        'description': 6
    },
    components: {
        Toolbar,
        SearchPanel
    },
    computed : {
        ...mapGetters('global/configuration/workflows', { docTypes: 'getWorkFlowDocTypes' }),
        collection() {
            return 'Workflows';
        },
        headers() {
            return [
                { text: this.$t("Наименование"), value: 'name', width: '300px' },
                { text: this.$t("Описание"), value: 'description' },
                { text: this.$t("Тип"), value: 'context_types', width: '300px', sortable: false },
                { text: this.$t("Версия"), value: 'version', width: '80px' }
            ];
        },
        search: {
            get: function() {
                return this.$store.getters['global/configuration/workflows/getTableSearch'];
            },
            set: _.debounce(function(v) {
                this.$store.commit('global/configuration/workflows/SET_TABLE_OPTION_PAGE', 1);
                this.$store.commit('global/configuration/workflows/SET_TABLE_SEARCH', v);
            }, 500)
        },
        options: {
            get: function() {
                return this.$store.getters['global/configuration/workflows/getTableOptions'];
            },
            set: function(newValue) {
                this.$store.commit('global/configuration/workflows/SET_TABLE_OPTION', newValue);
            }
        },
        filter() {
            return {
                ...this.options,
                SearchStr: this.search
            }
        }
    },
    data() {
        return {
            loading: true,
            total: 0,
            entities: [],
            dataSource: null,
            paginationPageCount: 0,
        }
    },    
    methods: {
        ...mapActions(['setOverlayVisible']),
        onToolbarClick(event, btn) {
            this[btn.Action](btn);
        },
        async getData(isRefresh = false) {
            let filterJson = this.getSerializedFilter();
            let newFilterObj = JSON.parse(filterJson);

            if (isRefresh === false && this.$_.isEqual(this.prevTableFilterObject, newFilterObj))
                return;

            this.setOverlayVisible({ visible: true });
            this.prevTableFilterObject = newFilterObj;
            this.total = 0;
            this.loading = true;

            let response = await httpAPI({
                url: `api/document-templates/list?collection=${this.collection}&filter=${filterJson}`,
                method: 'GET',
                headers: { 'isCommon': false },
            });

            this.entities = response?.data?.Payload?.data ?? [];
            this.total = response?.data?.Payload?.total ?? 0;
            this.loading = false;
            this.setOverlayVisible({ visible: false });
        },
        getSerializedFilter() {
            let { sortBy, sortDesc, page, itemsPerPage, SearchStr } = this.filter;

            let OrderDir = sortDesc.length <= 0 ? false : sortDesc[0];
            let sortColumn = sortBy.length <= 0 ? "name" : sortBy[0];
            let OrderBy = this.$options.columnIndex[sortColumn];

            let enterpriseId = this.$store.getters['global/auth/getUserInfo']?.EnterpriseId ?? null;
            return JSON.stringify({ SearchStr, OrderBy, OrderDir, Limit: itemsPerPage, Offset: (page - 1) * itemsPerPage, EnterpriseId: enterpriseId });
        },
        async Refresh() {
            await this.getData(true);
        },
        async rowClick(e, row) {
            this.setOverlayVisible({ visible: true });
            await this.$router.push({ name: 'WorkflowCard', query: { id: row.item.id }, params: { id: row.item.id }});
            this.setOverlayVisible({ visible: false });
        },
        getContextTypesViewValue(ctxTypes) {
            if (!ctxTypes)
                return this.$t("Не_указано");

            return this.docTypes.filter(dt => ctxTypes.includes(dt.id)).map(dt => this.$t(dt.name)).join(', ');
        }
    },
    watch: {
        filter: {
            handler() {
                this.getData();
            },
            deep: true,
        },
    },
    async created() {
        this.setOverlayVisible({ visible: true });        
        let fakeMenu =
        [
            { Action: "Refresh", Icon: "refresh", Items: null, Text: "Обновить", ToolTip: "Обновить_форму", Type: null, Localize: true }
        ];
        this.$store.commit('documents/toolbar/SET_MENU', { menu: fakeMenu });
        this.setOverlayVisible({ visible: false });
    }
}
</script>
